import { render, staticRenderFns } from "./schwarzes-brett.vue?vue&type=template&id=24308583&scoped=true&"
import script from "./schwarzes-brett.vue?vue&type=script&lang=js&"
export * from "./schwarzes-brett.vue?vue&type=script&lang=js&"
import style0 from "./schwarzes-brett.vue?vue&type=style&index=0&id=24308583&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24308583",
  null
  
)

export default component.exports